module.exports = __webpack_public_path__ + "static/media/index-bg08-02.e4db1a91.jpg";